import { serialize } from "cookie";

export type Cookie = {
    readonly name: string;
    readonly value: string;
};

export function serializeCookie({ name, value }: Cookie): string {
    return serialize(name, value);
}

export function mapCookieToHeaders(cookie?: Cookie): HeadersInit {
    if (cookie) {
        return { cookie: serializeCookie(cookie) };
    } else {
        return {};
    }
}
